import { getAction, getActionBlob, deleteAction, putAction, postAction, httpAction, postTimeOutAction } from '@/api/manage'

//首页统计
const getBuyAndSaleStatistics = (params) => getAction("/depotHead/getBuyAndSaleStatistics", params)
const getStreamingRecords = (params) => getAction("/hy/bill/hyBillRecord/getStreamingRecords", params)
const buyOrSalePrice = (params) => getAction("/depotItem/buyOrSalePrice", params)
//租户管理
const checkTenant = (params) => getAction("/tenant/checkIsNameExist", params)
const editTenant = (params) => putAction("/tenant/update", params)
const checkTenantRootName = (params) => getAction("/tenant/checkIsRootNameExist", params)
const checkTenantSocialCode = (params) => getAction("/tenant/checkTenantSocialCode", params)

//角色管理
const addRole = (params) => postAction("/role/add", params)
const editRole = (params) => putAction("/role/update", params)
const checkRole = (params) => getAction("/role/checkIsNameExist", params)
const roleAllList = (params) => getAction("/role/allList", params)
//用户管理
const registerUser = (params) => postAction("/user/registerUser", params)
const addUser = (params) => postAction("/user/addUser", params)
const editUser = (params) => putAction("/user/updateUser", params)
const getUserList = (params) => getAction("/user/getUserList", params)
const getUserBtnByCurrentUser = (params) => getAction("/user/getUserBtnByCurrentUser", params)
const queryPermissionsByUser = (params) => postAction("/function/findMenuByPNumber", params)
//机构管理
const queryOrganizationTreeList = (params) => getAction("/organization/getOrganizationTree", params)
const queryOrganizationById = (params) => getAction("/organization/findById", params)
const checkOrganization = (params) => getAction("/organization/checkIsNameExist", params)
//经手人管理
const addPerson = (params) => postAction("/person/add", params)
const editPerson = (params) => putAction("/person/update", params)
const checkPerson = (params) => getAction("/person/checkIsNameExist", params)
const getPersonByType = (params) => getAction("/person/getPersonByType", params)
const getPersonByNumType = (params) => getAction("/person/getPersonByNumType", params)
//账户管理
const addAccount = (params) => postAction("/account/add", params)
const editAccount = (params) => putAction("/account/update", params)
const checkAccount = (params) => getAction("/account/checkIsNameExist", params)
const getAccount = (params) => getAction("/account/getAccount", params)
//收支项目
const addInOutItem = (params) => postAction("/inOutItem/add", params)
const editInOutItem = (params) => putAction("/inOutItem/update", params)
const checkInOutItem = (params) => getAction("/inOutItem/checkIsNameExist", params)
const findInOutItemByParam = (params) => getAction("/inOutItem/findBySelect", params)
//仓库信息
const addDepot = (params) => postAction("/depot/add", params)
const editDepot = (params) => putAction("/depot/update", params)
const checkDepot = (params) => getAction("/depot/checkIsNameExist", params)
//商品属性
const editMaterialProperty = (params) => putAction("/materialProperty/update", params)
//商品类型
const queryMaterialCategoryTreeList = (params) => getAction("/materialCategory/getMaterialCategoryTree", params)
const queryMaterialCategoryById = (params) => getAction("/materialCategory/findById", params)
const checkMaterialCategory = (params) => getAction("/materialCategory/checkIsNameExist", params)
//商品管理
const addMaterial = (params) => postAction("/material/add", params)
const editMaterial = (params) => putAction("/material/update", params)
const checkMaterial = (params) => getAction("/material/checkIsExist", params)
const getMaterialBySelect = (params) => getAction("/material/findBySelect", params)
const getSerialMaterialBySelect = (params) => getAction("/material/getMaterialEnableSerialNumberList", params)
const getMaterialByParam = (params) => getAction("/material/getMaterialByParam", params)
const getMaterialByBarCode = (params) => getAction("/material/getMaterialByBarCode", params)
const getMaterialByBarCodeNew = (params) => getAction("/report/getByReturnNumber", params)
const getMaxBarCode = (params) => getAction("/material/getMaxBarCode", params)
const checkMaterialBarCode = (params) => getAction("/materialsExtend/checkIsBarCodeExist", params)
const batchUpdateMaterial = (params) => postAction("/material/batchUpdate", params)
//序列号
const addSerialNumber = (params) => postAction("/serialNumber/add", params)
const editSerialNumber = (params) => putAction("/serialNumber/update", params)
const checkSerialNumber = (params) => getAction("/serialNumber/checkIsNameExist", params)
const batAddSerialNumber = (params) => postAction("/serialNumber/batAddSerialNumber", params)
const getEnableSerialNumberList = (params) => getAction("/serialNumber/getEnableSerialNumberList", params)
const getEnableSerialNumberInfo = (params) => postAction("/serialNumber/getEnableSerialNumberInfo", params)
const addDepotHeadAndDetailCheck = (params) => getAction("/depotHead/addDepotHeadAndDetailCheck", params)
//多属性
const addMaterialAttribute = (params) => postAction("/materialAttribute/add", params)
const editMaterialAttribute = (params) => putAction("/materialAttribute/update", params)
const checkMaterialAttribute = (params) => getAction("/materialAttribute/checkIsNameExist", params)
const getMaterialAttributeNameList = (params) => getAction("/materialAttribute/getNameList", params)
const getMaterialAttributeValueListById = (params) => getAction("/materialAttribute/getValueListById", params)
//功能管理
const addFunction = (params) => postAction("/function/add", params)
const editFunction = (params) => putAction("/function/update", params)
const checkFunction = (params) => getAction("/function/checkIsNameExist", params)
const checkNumber = (params) => getAction("/function/checkIsNumberExist", params)
//系统配置
const addSystemConfig = (params) => postAction("/systemConfig/add", params)
const editSystemConfig = (params) => putAction("/systemConfig/update", params)
const checkSystemConfig = (params) => getAction("/systemConfig/checkIsNameExist", params)
const getCurrentSystemConfig = (params) => getAction("/systemConfig/getCurrentInfo", params)
const fileSizeLimit = (params) => getAction("/systemConfig/fileSizeLimit", params)
//平台参数
const addPlatformConfig = (params) => postAction("/platformConfig/add", params)
const editPlatformConfig = (params) => putAction("/platformConfig/update", params)
const getPlatformConfigByKey = (params) => getAction("/platformConfig/getInfoByKey", params)
//用户|角色|模块关系
const addUserBusiness = (params) => postAction("/userBusiness/add", params)
const editUserBusiness = (params) => putAction("/userBusiness/update", params)
const checkUserBusiness = (params) => getAction("/userBusiness/checkIsValueExist", params)
const updateBtnStrByRoleId = (params) => postAction("/userBusiness/updateBtnStr", params)
//计量单位
const addUnit = (params) => postAction("/unit/add", params)
const editUnit = (params) => putAction("/unit/update", params)
const checkUnit = (params) => getAction("/unit/checkIsNameExist", params)
//供应商|客户|会员
const addSupplier = (params) => postAction("/supplier/add", params)
const editSupplier = (params) => putAction("/supplier/update", params)
const checkSupplier = (params) => getAction("/supplier/checkIsNameAndTypeExist", params)
const findBySelectSup = (params) => postAction("/supplier/findBySelect_sup", params)
const findBySelectCus = (params) => postAction("/supplier/findBySelect_all", params)
const findBySelectRetail = (params) => postAction("/supplier/findBySelect_retail", params)
const findBySelectOrgan = (params) => postAction("/supplier/findBySelect_organ", params)

//供应商详情 companyDetail
const companyDetail = (params) => getAction("/sy/supplier/queryById", params)
//企业审核/商品审核详情
const companyApprovalDetail = (params) => getAction("/sy/examine/licenceExamine/examineById", params)
//审核通过/不通过
const editApproval = (params) => putAction("/sy/examine/licenceExamine/edit", params)
//同步到供应商
const syncToSupplier = (params) => postAction("/sy/supplier/syncToVendor", params)
//首营商品管理
//扫码获取商品信息
const getProductInfo = (params) => getAction("/sy/material/scanCodeForInfo", params)
//新增商品
const productAdd = (params) => postAction("/sy/material/add", params)
const productDelete = (params) => deleteAction("/sy/material/delete", params)
// 新增企业证照
const getProductLisence = (params) => getAction("/sy/material/materialLicence/list", params)
const getManufactureLisence = (params) => getAction("/sy/supplierLicence/list", params)
const licenseAdd = (params) => postAction("/sy/material/materialLicence/add", params)
const licenseEdit = (params) => putAction("/sy/material/materialLicence/edit", params)
const licenseDelete = (params) => deleteAction("/sy/material/materialLicence/delete", params)
const ManufactureLicenseDelete = (params) => deleteAction("/sy/supplierLicence/delete", params)
const manufactureLicenseEdit = (params) => putAction("/sy/supplierLicence/edit", params)
const supplierLicenseAdd = (params) => postAction("/sy/supplierLicence/add", params)
//商品管理--查看详情
const getProductDetail = (params) => getAction("/sy/material/queryById", params)
//商品证照-查看商品
const searchProductList = (params) => getAction("/sy/material/materialLicence/queryMaterialByLicenceCode", params)
//企业新增/编辑/删除
const supplyAdd = (params) => postAction("/sy/supplier/add", params)
const supplyEdit = (params) => postAction("/sy/supplier/edit", params)
const supplyDelete = (params) => deleteAction("/sy/supplier/delete", params)
// 企业提交审核
const supplyApproval = (params) => postAction("/sy/supplier/submissionApproval", params)
const materialApproval = (params) => postAction("/sy/material/submissionApproval", params)
// 收货查验
// 获取查验商品详情
const getInspectionProduct = (params) => getAction("/hy/bill/hyBillDetailRecord/list", params)
const getInfo = (params) => getAction("/hy/bill/hyBillRecord/queryById", params)
const getInspectionProductCode = (params) => getAction("/hy/bill/hyBillCodeRecord/list", params)
const exportProductList = (params) => getAction("/hy/bill/hyBillRecord/exportValidationExcelRecordId", params)
const getOutProductList = (params) => getAction("/hy/bill/hyBillRecord/getOrderNumberDetail", params)
const synchronousTraceability = (params) => getAction("/hy/bill/hyBillRecord/syncTrace", params)
//模板编辑/新增
const updateTemplate = (params)=>postAction("/print/updateTemplate",params);
const addTemplate = (params)=>postAction("print/addTemplate",params);
const delTemplate = (params)=>deleteAction("print/delTemplate/" + params);
const delTemplate2 = (params)=>postAction("/htmlTemplate/modifyStatus" , params);
const getPublicTemplates = (params)=>getAction("print/getPublicTemplates",params);
const templateDetial = (params)=>getAction("/htmlTemplate/detailsById",params);
// 工序管理
// 工序列表
const getAll = (params)=>postAction("/process/getAll", params);
// 工艺列表
const getCraftAll = (params)=>postAction("/craft/traceProdCraft/list",params);
// 根据商品id获取工艺类别列表
const getCraftByMaterialId = (params)=>getAction("/craft/traceProdCraft/getCraftByMaterialId",params);
// 查询工艺绑定的工序
const queryProcessByCraftId = (params)=>getAction("/craft/traceProdCraft/queryProcessByCraftId",params);
// 查询是否有未完成订单
const getCookies = (params)=>getAction("/process/traceProdPlanRecord/getOngoingTask",params);
// 放弃拉回计划
const abandonTask = (params)=>getAction("/process/traceProdPlanRecord/abandonTask",params);
// 新增工序
const addProcess = (params)=>postAction("/process/addProcess",params);
// 工序上传图片
const uploadFiles = (params)=>postAction("/htmlTemplate/uploadFiles",params);
// 新增工艺
const addTraceProdCraft = (params)=>postAction("/craft/traceProdCraft/add",params);
// 编辑工序
const updateProcess = (params)=>putAction("/process/updateProcess",params);
// 编辑工艺
const editTraceProdCraft = (params)=>postAction("/craft/traceProdCraft/edit",params);
// 删除工序
const delProcess = (params)=>deleteAction("/process/delProcess/" + params);
// 删除工艺
const delCraft = (params)=>deleteAction("/craft/traceProdCraft/delete/", params);
// 获取所有模版
const getAllTemplates = (params)=>getAction("/formTemplate/getAllTemplates",params);
// 获取所有追溯模版
const getTemplateList = (params)=>postAction("/formTemplate/list",params);
// 获取所有规则
const getAllRules = (params)=>getAction("/codeRules/fzRule/getAllRules",params);
// 绑定规则
const bindRule = (params)=>postAction("/process/bindRule",params);
// 复制规则/codeRules/fzRule/copyRule
const copyRule = (params)=>getAction("/codeRules/fzRule/copyRule",params);
// 绑定模版
const bindTemplate = (params)=>postAction("/process/bindTemplate",params);
// 绑定工序
const bindingProcess = (params)=>postAction("/craft/traceProdCraft/bindingProcess",params);
// 获取绑定的模版和规则/process/getProcess
const getProcess = (params)=>getAction(`/process/getProcess/${params}`);
// 绑定类别
const bindingCategory = (params)=>postAction("/craft/traceProdCraft/bindingCategory",params);
// 获取绑定的类别
const queryCategoryByCraftId = (params)=>getAction("/craft/traceProdCraft/queryCategoryByCraftId",params);
// 保存追溯信息
const addPlan = (params)=>postAction("/process/traceProdPlanRecord/add",params);
// 获取生产任务分页列表
const getTraceProdPlanRecordList = (params)=>postAction("/process/traceProdPlanRecord/list",params);
// 通过搜索获取生产任务列表
const getTaskListBySearch = (params)=>postAction("/process/traceProdPlanRecord/pageForWork",params);
// 保存扫码数据
const traceSaveForPlanId = (params)=>postAction("/trace/traceSaveForPlanId",params);
// 扫码临时保存
const saveTempCode = (params)=>postAction("/process/traceProdPlanRecord/saveTempCode",params);
// 获取码段列表
const getCodeSegmentList = (params)=>postAction("/trace/traceCodeDetail",params);
// 工序日志再次上传
const traceSaveForEventId = (params)=>getAction("/trace/traceSaveForEventId",params);

// 根据商品id获取对象码生码规则信息
const getRuleMesByMaterialId = (params)=>getAction("/craft/traceProdCraft/getRuleMesByMaterialId",params);
const getRuleMesByPlanId = (params)=>getAction("/craft/traceProdCraft/getRuleMesByPlanId",params);
// 追溯模版新增/编辑
const traceModuleEdit = (params)=>postAction("/formTemplate/modify",params);
// 追溯码信息查询
const anayliseCodeNoTemplate = (params)=>postAction("/codeRules/fzIdcode/anayliseCodeNoTemplate",params);
// 工序日志 
const getTraceEventList = (params)=>postAction("/trace/getTraceEventList",params);
// 工序日志---详情
const getTraceEventCodes = (params)=>getAction("/trace/getTraceEventCodes",params);
// 追溯模版详情
const traceModuleDetail = (params)=>getAction("/formTemplate/detailsById",params);
// 删除追溯模版
const delTraceModule = (params)=>postAction("/formTemplate/modifyStatus", params);
// 获取追溯生码信息
const getCodeForm = (params) => getAction("/codeRules/fzIdcode/beforeIdCode?ruleId=" + params.ruleId)
// 下载生码列表 
const downloadCodeList = (params) => getAction("/codeRules/fzIdcode/exportTxtBybantchId?bantchId=" + params.id)
// 获取追溯生码字典
const getCodeFormDict = (params) => getAction("/codeRules/fzNodeDictionaryData/queryDictDataByDictId", params)
// 生码接口
const generateCodeByParameter = (params) => postAction("/codeRules/fzIdcode/generateCodeByParameter", params)
// 事件绑定规则接口
const traceRule = (params) => getAction("/codeRules/fzRule/modifyForDyncTemplate", params)
// 追溯最终上传接口
const traceSave = (params) => postAction("/trace/traceSave", params)
// 根据工序ID查询事件列表
const getEventListByProcessId = (params) => postAction("/trace/eventTrace/list", params)
// 事务码下物码详情查询
const getObjectDetaillist = (params) => postAction("/trace/eventTrace/objectDetaillist", params)
// 防伪验证
const getAfVerificationList = (params) => getAction("/productPi/piList", params)
//防伪验证打开开关
const rcRecordSwitch = (params) => postAction("/productPi/switchPiSecurity", params)
const convertStorage = (params) => postAction("/dataAcquisitionAccumulated/convertStorage", params)
const queryCodeById = (params) => getAction("/hy/bill/hyBillCodeRecord/queryCodeById", params)
//查询详情
const getpiSecurityInfo = (params) => getAction("/productPi/piSecurityInfo", params)
//单据相关
const findBillDetailByNumber = (params) => getAction("/depotHead/getDetailByNumber", params)
const findStockByDepotAndBarCode = (params) => getAction("/depotItem/findStockByDepotAndBarCode", params)
const getBatchNumberList = (params) => getAction("/depotItem/getBatchNumberList", params)
const findFinancialDetailByNumber = (params) => getAction("/accountHead/getDetailByNumber", params)
// 采集信息
const submitto = (params) => postAction("/dataAcquisitionAccumulated/acquisitionConfiqueryMaterialCategoryTreeListrm", params)
const collectModify = (params) => postAction("/dataAcquisitionAccumulatedV2/acquisitionAddModify", params)
// 采集信息激活
const gatheractivation = (params) => postAction("/dataAcquisitionAccumulated/acquisitionConfirm", params)
// 采集信息明细
const gatherDetails = (params) => getAction("/dataAcquisition/acquisitionInfo", params)

const batchDetails = (params) => getAction("/dataAcquisitionAccumulatedV2/batchNumberDetail", params)

const drugTrace = (params) => getAction("/trace/medicine/detail/listByInfo", params)

const instrumentTrace = (params) => getAction("/trace/machine/detail/listByInfo", params)
const codeDetails = (params) => getAction("/dataAcquisitionAccumulatedV2/codeDetail", params)
// 获取仓库信息
const getwarehouse = (params) => getAction("/depot/findDepotByCurrentUser", params)
// 入库校验
const postWarehousingCheck = (params) => postTimeOutAction("/dataAcquisitionAccumulated/addDepotHeadAndDetailCkeck", params)
// 根据单号查询详情
const accumulategetByNumber = (params) => getAction("/accumulate/getByNumber", params)
export const accumulategetByNumberNew = (params) => getAction("/report/getByNumber", params)
// 入库
const postWarehousing = (params) => postTimeOutAction("/dataAcquisitionAccumulated/addDepotHeadAndDetail", params)
// 获取账号信息
const getUser = (params) => getAction("/user/getUserById", params)
// 防伪预警处理
const securityWarning = (params) => getAction("/securityWarning/deal", params)
// 防伪参数配置
const updateSecurityConfig = (params) => getAction("/securityWarning/updateSecurityConfig", params)
// 防伪参数配置
const selectSecurityConfig = (params) => getAction("/securityConfig/selectSecurityConfig", params)
// 窜货预警处理
const transshipment = (params) => getAction("/transshipment/deal", params)
// 其它入库查询序列号
const getSerNumbers = (params) => getAction("/depotItem/getSerNumbers", params)
// 经销商新增用户
const addUserNew = (params) => postAction("/user/addUserNew", params)
// 获取地址信息
const getaddressData = (params) => getAction("/common/address", params)
// 防窜货配置
const fchApi = (params) => putAction("/supplier/update", params)
const updateStorage = (params) => putAction("/dataAcquisitionAccumulated/updateStorage", params)
//新增主营区域
const addLocationName = (params) => getAction("/supplier/addLocationName", params)
// 根据父级节点id查询信息
const getParentApi = (params) => getAction("/supplier/list", params)
// 获取账号信息接口
const getuserApi = (params) => getAction("/user/list", params)
// 解除绑定账号信息
const unBindUser = (params) => getAction("/supplier/unBindUser", params)
const accumulate = (params) => getAction("/accumulate/list", params)
// 调整记录
const udiStockRecord = (params) => getAction("/udiStockRecord/getStockRecordsByStockId", params)
// UDI出库统计查看
const getByMaterialId = (params) => getAction("/saleRecordAcc/getByNumber", params)
// UDI退货统计查看
const getByNumber = (params) => getAction("/returnRecordAcc/getByNumber", params)
// 删除DI
const productDidel = (params) => getAction("/productDi/delete", params)
// 修改DI
const updateProductDi = (params) => postAction("/productDi/updateProductDi", params)
// 注册DI
const createProductDi = (params) => postAction("/productDi/createProductDi", params)
const getLastDetail = (params) => postAction("/tempInStorageController/getLastDetail?code="+params.code, params)
const addMedicineDeopHead = (params) => postAction("/tempInStorageController/addMedicineDeopHead?infoId="+params.infoId, params)
const addMedicineDeopHeadOut = (params) => postAction("/tempInStorageController/addMedicineDeopHeadOut?infoId="+params.infoId+'&orgId='+params.orgId, params)
const modifyHeader = (params) => postAction("/tempInStorageController/modifyHeader?headId="+params.headId, params)
// 分类编码查询列表
const udiCategory = (params) => getAction("/public/udiCategory", params)
// 获取DI详情
const Didetail = (params) => getAction("/productDi/detail", params)
// 注册证列表
const listCertificate = (params) => getAction("/unit/listCertificate", params)
// 药监局申报
const getdetailApi = (params) => getAction("/productDi/detail", params)
// 药监局申报确认接口
const declareDi = (params) => postAction("/productDiV2/declare", params)
// 包装规格列表
const getProductSpecification = (params) => getAction("/productDi/getProductSpecification", params)
// 新增包装规格
const insertPackage = (params) => postAction("/productDi/insertPackage", params)
// 编辑包装规格
const updatePackage = (params) => postAction("/productDi/updatePackage", params)
// 获取可添加的包装规格
const getSpecification = (params) => getAction("/productDi/getSpecification", params)
// 注册证获取详情
const certificateDetail = (params) => getAction("/unit/certificateDetail", params)
// 编辑注册证
const updateCertificate = (params) => postAction("/unit/updateCertificate", params)
// 添加注册证
const createCertificate = (params) => postAction("/unit/createCertificate", params)
// 生成PI查询基本标识信息
const addPIinfo = (params) => getAction("/productPi/addPI", params)
//新增PI
const insertProductPI = (params) => postAction("/productPi/insertProductPI", params)
// 查看PI记录
const piRecord = (params) => getAction("/productPi/piRecord", params)
const exportPiExcelByPiId = (params) => getActionBlob("/productPi/exportPiExcelByPiId", params) // 导出
// 查看PI列表
const piInfoApi = (params) => getAction("/productPi/piInfo", params)
const asyncDiInfoApi = (params) => getAction("/idcode/business/sycUdiMes", params)
const synchronousApi = (params) => getAction("/report/syncTrace", params)
// 查看PI列表产品信息
const getPIInfo = (params) => getAction("/productPi/getPIInfo", params)
const downloadExcelApi = (params) => getAction("/depotHead/exportPeerList", params)
// 打印列表
const printgetAll = (params) => getAction("/print/getAll", params)
// 获取所有模版列表
const getAllModules = (params) => getAction("/print/getAllModules", params)
// 生产管理过程中获取要打印的列表generateCodeForPrint
const generateCodeForPrint = (params) => postAction("/codeRules/fzIdcode/generateCodeForPrint", params)
// 删除注册证
const certificateDelete = (params) => getAction("/unit/certificateDelete", params)
// 获取公司信息
const getCurrentInfo = (params) => getAction("/systemConfig/getCurrentInfo", params)
// 修改公司信息
const putCompany = (params) => putAction("/systemConfig/update", params)
//首营
//首营供应商管理--列表
const campList = (params) => postAction("/firstCamp/fcFirstCampLedger/list", params)
//首营台账--新增
const ledgerAdd = (params) => postAction("/firstCamp/fcFirstCampLedger/add", params)
//首营台账--编辑
const ledgerEdit = (params) => postAction("/firstCamp/fcFirstCampLedger/edit", params)
//首营台账--删除
const ledgerDelete = (params) => deleteAction("/firstCamp/fcFirstCampLedger/delete", params)
//抽送检单--新增
const inspectionAdd = (params) => postAction("/quality/samplingInspection/add", params)
//抽送检单--编辑
const inspectionEdit = (params) => postAction("/quality/samplingInspection/edit", params)
//抽送检单--删除
const inspectionDelete = (params) => deleteAction("/quality/samplingInspection/delete", params)

//不合格品确认单--新增
const unqualifiedAdd = (params) => postAction("/firstCamp/fcDisqualifiedConfirmedSheet/add", params)
//不合格品确认单--编辑
const unqualifiedEdit = (params) => postAction("/firstCamp/fcDisqualifiedConfirmedSheet/edit", params)
//不合格品确认单--删除
const unqualifiedDelete = (params) => deleteAction("/firstCamp/fcDisqualifiedConfirmedSheet/delete", params)
//不合格品处理单--新增
const handledAdd = (params) => postAction("/quality/disqualifiedProcess/add", params)
//不合格品处理单--编辑
const handleEdit = (params) => postAction("/quality/disqualifiedProcess/edit", params)
//不合格品处理单--删除
const handleDelete = (params) => deleteAction("/quality/disqualifiedProcess/delete", params)
//召回处理--新增
const recallAdd = (params) => postAction("/quality/recallProcess/add", params)
//召回处理--编辑
const recallEdit = (params) => postAction("/quality/recallProcess/edit", params)
//召回处理--删除
const recallDelete = (params) => deleteAction("/quality/recallProcess/delete", params)
//拒收处理--新增
const refusalAdd = (params) => postAction("/quality/refuseAccept/add", params)
//拒收处理--编辑
const refusalEdit = (params) => postAction("/quality/refuseAccept/edit", params)
//拒收处理--删除
const refusalDelete = (params) => deleteAction("/quality/refuseAccept/delete", params)
const getAllMaterials = (params) => getAction("/material/getAllMaterials", params)
// 质量管理
// 售后服务列表getQualityList
const getAfterServiceList = (params) => getAction("/quality/afterSales/list", params)
// 审核
const updateAuditStatus = (params) => getAction("/quality/afterSales/updateAuditStatus", params)
// 巡检审核
const updateQualityStatus = (params) => getAction("/quality/spotInspection/updateAuditStatus", params)
// 质量审核
const updateInverstigateReportStatus = (params) => getAction("/quality/inverstigateReport/updateAuditStatus", params)
// 新增售后服务
const addAfterService = (params) => postAction("/quality/afterSales/add", params)
// 编辑售后服务列表
const editAfterService = (params) => putAction("/quality/afterSales/edit", params)
// 生成单号
const generateCode = (params) => getAction("/quality/afterSales/generateCode", params)
// 删除售后服务
const deleteService = (params) => deleteAction("/quality/afterSales/delete", params)
// 巡检编辑
const editSpot = (params) => putAction("/quality/spotInspection/edit", params)
// 巡检查询
const getSpotDetail = (params) => getAction("/quality/spotInspection/queryById", params)
const getSpot = (params) => putAction("/quality/inspectionAssociation/edit", params)
// 质量事故列表getQualityList
const getQualityList = (params) => getAction("/quality/inverstigateReport/list", params)
// 新增质量事故
const addQuality= (params) => postAction("/quality/inverstigateReport/add", params)
// 生成事故处理单号
const generateQualityCode = (params) => getAction("/quality/inverstigateReport/generateCode", params)
// 生成事故处理单号
// const generateQualityCode = (params) => getAction("/quality/inverstigateReport/generateCode", params)
// 删除质量事故
const deleteQuality = (params) => deleteAction("/quality/inverstigateReport/delete", params)
// 编辑质量事故
const editQuality = (params) => putAction("/quality/inverstigateReport/edit", params)
// 不良事件列表
const getAdverseList = (params) => getAction("/quality/badMonitor/list", params)
// 新增不良事件
const addAdverse= (params) => postAction("/quality/badMonitor/add", params)
// 编辑不良事件
const editAdverse = (params) => putAction("/quality/badMonitor/edit", params)
// 不良事件审核
const updateAdverseStatus = (params) => getAction("/quality/badMonitor/updateAuditStatus", params)
// 删除不良事件
const deleteAdverse = (params) => deleteAction("/quality/badMonitor/delete", params)
// 运输冷链审核
const updateCodeChainStatus = (params) => getAction("/quality/transportMonitor/updateAuditStatus", params)
// 获取审批列表
const getApproveList = (params) => getAction("/sy/examine/licenceExamine/queryPageByCondition", params)
// 审核列表--审核
const editApprovalState = (params) => putAction("/sy/examine/licenceExamine/editSecond", params)
// 冷链运输审核
const updateCodeStatus = (params) => getAction("/quality/transportMonitor/updateAuditStatus", params)
// 冷链运输详情
const getCodeDetail = (params) => getAction("/quality/transportMonitor/queryById", params)
// 售后详情
const getAfterDetail = (params) => getAction("/quality/afterSales/queryById", params)
// 质量事故运输详情
const getQualityDetail = (params) => getAction("/quality/inverstigateReport/queryById", params)
// 不良事故详情
const getAdverseDetail = (params) => getAction("/quality/badMonitor/queryById", params)
// 获取审核详情
const getApprovalDetail = (params) => getAction("/sy/examine/licenceExamine/getDetailInfo", params)
// 点击编辑获取详情
const getDetailList = (params) => getAction("/quality/inspectionAssociation/getDetailList", params)
// 获取模版文件流
const getTraceModuleInfo = (params) => postAction("/htmlTemplate/download", params)

//编码规则模板

const modifyForTemplate = (params)=>getAction("/codeRules/fzRule/modifyForTemplate",params);

const getTenant = (params)=>getAction("/authorize/getTenant/"+params,);
const authorizeList = (params)=>getAction("/authorize/authorizeList",params);
const insertAuthorize = (params)=>postAction("/authorize/insertAuthorize",params);
const updateAuthorize = (params)=>putAction("/authorize/updateAuthorize",params);
const deleteAuthorize = (params)=>deleteAction("/authorize/deleteAuthorize/"+params);
const getAuthorize = (params)=>getAction("/authorize/getAuthorize/"+params);
const agreeAuthorize = (params)=>postAction("/authorize/agreeAuthorize",params);
const addressget = (params)=>getAction("/address/get",params);
const addresslist = (params)=>getAction("/address/list",params);
const carrierMangaementadd = (params)=>postAction("/carrier/carrierManagement/add",params);
const carrierMangaementedit = (params)=>putAction("/carrier/carrierManagement/edit",params);
const carrierMangaementqueryById = (params)=>getAction("/carrier/carrierManagement/queryById",params);
const waybillqueryOutOrderNumbers = (params)=>getAction("/waybill/waybillManagement/queryOutOrderNumbers",params);
const carrierManagementqueryCarrierCompany = (params)=>getAction("/carrier/carrierManagement/queryCarrierCompany",params);
const getCarrierUserByCarrierId = (params)=>getAction("/carrier/carrierInformation/getCarrierUserByCarrierId",params);
const queryCustomerByOutOrderNumber = (params)=>getAction("/waybill/waybillManagement/queryCustomerByOutOrderNumber",params);
const waybillManagementadd = (params)=>postAction("/waybill/waybillManagement/add",params);
const waybillManagementedit = (params)=>putAction("/waybill/waybillManagement/edit",params);
const waybillManagementqueryById = (params)=>getAction("/waybill/waybillManagement/queryById",params);
const waybillManagementgetCompanyInfo = (params)=>getAction("/waybill/waybillManagement/getCompanyInfo");
const systemConfigupdate = (params)=>putAction("/systemConfig/update",params);
const unitlistCertificate = (params)=>getAction("/unit/listCertificate",params);
const addressgetByRegionCode = (params)=>getAction("/address/getByRegionCode",params);
const getMinusStockFlag = (params)=>getAction("/account/getMinusStockFlag");
const getMaterialBatchNumber = (params)=>getAction("/serialNumber/getMaterialBatchNumber",params);


export {
  getAfterServiceList,
  getTaskListBySearch,
  getAdverseList,
  addAdverse,
  editAdverse,
  getApproveList,
  getQualityList,
  updateCodeStatus,
  getCodeDetail,
  getAfterDetail,
  getQualityDetail,
  getAdverseDetail,
  editSpot,
  getSpotDetail,
  getSpot,
  getDetailList,
  updateAdverseStatus,
  updateAuditStatus,
  updateCodeChainStatus,
  updateQualityStatus,
  updateInverstigateReportStatus,
  editApprovalState,
  getApprovalDetail,
  addAfterService,
  generateQualityCode,
  editQuality,
  addQuality,
  deleteQuality,
  editAfterService,
  generateCode,
  deleteService,
  getMaterialBatchNumber,
  getMinusStockFlag,
  addressgetByRegionCode,
  unitlistCertificate,
  systemConfigupdate,
  waybillManagementgetCompanyInfo,
  waybillManagementqueryById,
  waybillManagementedit,
  waybillManagementadd,
  queryCustomerByOutOrderNumber,
  getCarrierUserByCarrierId,
  carrierManagementqueryCarrierCompany,
  waybillqueryOutOrderNumbers,
  carrierMangaementqueryById,
  carrierMangaementadd,
  carrierMangaementedit,
  addresslist,
  addressget,
  traceRule,
  deleteAdverse,
  uploadFiles,
  getEventListByProcessId,
  getCodeFormDict,
  getTraceModuleInfo,
  getObjectDetaillist,
  delTraceModule,
  generateCodeByParameter,
  traceModuleEdit,
  anayliseCodeNoTemplate,
  getTraceEventList,
  getTraceEventCodes,
  traceModuleDetail,
  deleteAuthorize,
  updateAuthorize,
  agreeAuthorize,
  getAuthorize,
  insertAuthorize,
  authorizeList,
  getTenant,
  modifyForTemplate,
  templateDetial,
  delTemplate2,
  getStreamingRecords,
  modifyHeader,
  addMedicineDeopHeadOut,
  addMedicineDeopHead,
  getLastDetail,
  instrumentTrace,
  drugTrace,
  traceSave,
  getEnableSerialNumberInfo,
  addDepotHeadAndDetailCheck,
  getAllMaterials,
  queryCodeById,
  downloadCodeList,
  convertStorage,
  synchronousApi,
  synchronousTraceability,
  getInspectionProduct,
  getOutProductList,
  exportProductList,
  getInspectionProductCode,
  supplierLicenseAdd,
  supplyApproval,
  materialApproval,
  supplyAdd,
  supplyEdit,
  supplyDelete,
  getProductLisence,
  licenseAdd,
  licenseEdit,
  licenseDelete,
  getAll,
  getCraftAll,
  getCraftByMaterialId,
  queryProcessByCraftId,
  getCookies,
  abandonTask,
  bindingProcess,
  getProcess,
  bindingCategory,
  queryCategoryByCraftId,
  addProcess,
  addTraceProdCraft,
  updateProcess,
  editTraceProdCraft,
  delProcess,
  delCraft,
  getAllTemplates,
  getTemplateList,
  getAllRules,
  bindRule,
  copyRule,
  bindTemplate,
  getCodeSegmentList,
  traceSaveForEventId,
  addPlan,
  saveTempCode,
  getTraceProdPlanRecordList,
  traceSaveForPlanId,
  getRuleMesByMaterialId,
  getRuleMesByPlanId,
  manufactureLicenseEdit,
  getManufactureLisence,
  ManufactureLicenseDelete,
  productDelete,
  getProductDetail,
  searchProductList,
  companyDetail,
  companyApprovalDetail,
  editApproval,
  syncToSupplier,
  productAdd,
  getProductInfo,
  getAfVerificationList,
  rcRecordSwitch,
  getpiSecurityInfo,
  campList,
  ledgerAdd,
  ledgerEdit,
  ledgerDelete,
  getCodeForm,
  refusalAdd,
  refusalEdit,
  refusalDelete,
  recallAdd,
  recallEdit,
  recallDelete,
  handledAdd,
  handleEdit,
  handleDelete,
  unqualifiedAdd,
  unqualifiedEdit,
  unqualifiedDelete,
  inspectionAdd,
  inspectionEdit,
  inspectionDelete,
  certificateDelete,
  printgetAll,
  getAllModules,
  generateCodeForPrint,
  getPIInfo,
  piInfoApi,
  piRecord,
  exportPiExcelByPiId,
  insertProductPI,
  addPIinfo,
  createCertificate,
  updateCertificate,
  certificateDetail,
  getSpecification,
  updatePackage,
  insertPackage,
  getProductSpecification,
  declareDi,
  getdetailApi,
  listCertificate,
  Didetail,
  udiCategory,
  createProductDi,
  updateProductDi,
  productDidel,
  getByNumber,
  getByMaterialId,
  udiStockRecord,
  accumulate,
  unBindUser,
  getuserApi,
  getParentApi,
  addLocationName,
  fchApi,
  getaddressData,
  addUserNew,
  getSerNumbers,
  transshipment,
  selectSecurityConfig,
  updateSecurityConfig,
  securityWarning,
  getUser,
  postWarehousing,
  postWarehousingCheck,
  getwarehouse,
  updateTemplate,
  addTemplate,
  delTemplate,
  getPublicTemplates,
  gatherDetails,
  submitto,
  collectModify,
  gatheractivation,
  getBuyAndSaleStatistics,
  buyOrSalePrice,
  checkTenant,
  checkTenantRootName,
  checkTenantSocialCode,
  editTenant,
  addRole,
  editRole,
  checkRole,
  roleAllList,
  registerUser,
  addUser,
  editUser,
  getUserList,
  getUserBtnByCurrentUser,
  queryPermissionsByUser,
  queryOrganizationTreeList,
  queryOrganizationById,
  checkOrganization,
  addPerson,
  editPerson,
  checkPerson,
  getPersonByType,
  getPersonByNumType,
  addAccount,
  editAccount,
  checkAccount,
  getAccount,
  addInOutItem,
  editInOutItem,
  checkInOutItem,
  findInOutItemByParam,
  addDepot,
  editDepot,
  checkDepot,
  editMaterialProperty,
  queryMaterialCategoryTreeList,
  queryMaterialCategoryById,
  checkMaterialCategory,
  addMaterial,
  editMaterial,
  checkMaterial,
  getMaterialBySelect,
  getSerialMaterialBySelect,
  getMaterialByParam,
  getMaterialByBarCode,
  getMaxBarCode,
  checkMaterialBarCode,
  batchUpdateMaterial,
  addSerialNumber,
  editSerialNumber,
  checkSerialNumber,
  batAddSerialNumber,
  getEnableSerialNumberList,
  addMaterialAttribute,
  editMaterialAttribute,
  checkMaterialAttribute,
  getMaterialAttributeNameList,
  getMaterialAttributeValueListById,
  addFunction,
  editFunction,
  checkFunction,
  checkNumber,
  addSystemConfig,
  editSystemConfig,
  checkSystemConfig,
  getCurrentSystemConfig,
  fileSizeLimit,
  addPlatformConfig,
  editPlatformConfig,
  getPlatformConfigByKey,
  addUserBusiness,
  editUserBusiness,
  checkUserBusiness,
  updateBtnStrByRoleId,
  addUnit,
  editUnit,
  checkUnit,
  addSupplier,
  editSupplier,
  checkSupplier,
  findBySelectSup,
  findBySelectCus,
  findBySelectRetail,
  findBySelectOrgan,
  findBillDetailByNumber,
  findStockByDepotAndBarCode,
  getBatchNumberList,
  findFinancialDetailByNumber,
  accumulategetByNumber,
  getCurrentInfo,
  putCompany,
  batchDetails,
  codeDetails,
  asyncDiInfoApi,
  downloadExcelApi,
  getInfo,
  getMaterialByBarCodeNew
}



